<template>
    <div class="search">
        <div class="search_box">
            <div class="search_input">
                <form @submit.prevent action="#">
                    <span class="search_icon" @click="getSearchInfo()"></span>
                    <input type="search" :placeholder="$t('nav.online')+' '+$t('footerNav[1]')+' '+$t('nav.activity')" v-model="keywords" @blur="searchIos" @keypress="searchAndroid">
                    <span class="delete_btn" @click="deleteContent()"></span>
                </form>

                <!--<span class="voice"></span>-->
            </div>
        </div>
        <div style='width: 100%;text-align: center;margin-top: 75px ;' v-if="isEmptyData"><img src='../../assets/images/no_page.png' alt='没有数据' width="160"></div>
        <div v-else>
            <searchNews v-if="isShowNews" v-for="(n,i) in activity_list.news" :news="n" :key="i"></searchNews>
            <searchActivity  v-else-if="isShowActivity" v-for="(n,i) in activity_list.information" :activity="n" :key="i"></searchActivity>
            <searchTicket  v-else-if="isShowTicket" v-for="(n,i) in activity_list.product" :ticket="n" :key="i"></searchTicket>
        </div>

    </div>
</template>

<script>
import searchNews from "../../components/activitys/searchNews";
import searchActivity from "../../components/activitys/searchActivity";
import searchTicket from "../../components/activitys/searchTicket";
export default {
  name: "search",
  components: {
    searchNews,
    searchActivity,
    searchTicket
  },
  inject: ["showMsg"],
  data: function() {
    return {
      word: null,
      keywords: "",
      isEmptyData: false,
      isShowActivity: false,
      isShowNews: false,
      isShowTicket: false
    };
  },
  created: function() {
    this.keywords = this.$route.query.keywords;
    this.getSearchInfo();
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "search_title");
  },
  methods: {
    getSearchInfo() {
      this.word = this.keywords;
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + "/home/index/fullSearch",
        dataType: "json",
        data: {
          keywords: this.word,
          lang: window.$lang
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.$store.commit("set_activity_list", res.data.result);
            if (
              res.data.result.product.length === 0 &&
              res.data.result.news.length === 0 &&
              res.data.result.information.length === 0
            ) {
              this.isEmptyData = true;
            } else {
              this.isEmptyData = false;
              this.showPage(res.data.result);
            }
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    showPage(data) {
      this.isShowNews = data.news.length !== 0;
      this.isShowTicket = data.product.length !== 0;
      this.isShowActivity = data.information.length !== 0;
    },
    deleteContent() {
      this.keywords = "";
    },
    searchIos() {
      //ios点击完成失去焦点搜索
      /* this.search();*/
      this.getSearchInfo();
    },
    searchAndroid(event) {
      //android点击搜索，未能失去焦点，故失去焦点事件无法触发，单可以调用键盘事件处理
      if (event.keyCode === 13) {
        //如果按的是enter键 13是enter
        event.preventDefault(); //禁止默认事件（默认是换行）
        /* this.search();*/
        this.getSearchInfo();
      }
    }
  },
  computed: {
    activity_list: function() {
      return this.$store.state.activity.activity_list;
    },
    weburl: function() {
      return this.$store.state.weburl;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/less/common";
.search {
  background: @bg;
  width: @width;
  padding: 10px 0 1px 0;
  .media;
  .search_box {
    background: @font-primary;
    width: calc(@width - 20px);
    padding: 10px;
    margin-bottom: 10px;
    .search_input {
      width: @width;
      height: 44px;
      line-height: $height;
      .border(1px; solid; @word);
      .border-radius(20px);
      span,
      input {
        float: left;
        height: @width;
      }
      .search_icon {
        width: 30px;
        background: url("../../assets/publicImg/find_btn_icon.png") no-repeat
          7px 12px;
        background-size: 18px auto;
      }
      .delete_btn {
        width: 30px;
        background: url("../../assets/publicImg/cancel_btn_icon.png") no-repeat
          7px 12px;
        background-size: 20px auto;
      }
      .voice {
        width: 30px;
        background: url("../../assets/publicImg/trum_btn_icon.png") no-repeat
          9px 9px;
        background-size: 16px auto;
      }
      input {
        /*width: 70%;*/ //修改
        width: 79%;
      }
    }
  }
}
form {
  .img;
}
</style>
